export default __webpack_public_path__ + "static/media/database.6223b1e3.svg";